import React, {useEffect, useState} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography'
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {useDropzone} from "react-dropzone";
import DosAndDonts from '../components/DosAndDonts';
import {IconButton, Paper} from "@material-ui/core";
import {CloudUpload} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        minHeight: 200,
        position: 'relative',
    },
    helpText: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        top: 0,
        left: 0,
        minHeight: 200,
        marginTop: theme.spacing(1),
        width: '100%',
        height: '100%',
        '& p': {
            marginTop: theme.spacing(0.5),
        }
    },
    thumbsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 16
    },
    thumb: {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 8,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    },
    thumbInner: {
        display: 'flex',
        minWidth: 0,
        overflow: 'hidden',
        '& img': {
            display: 'block',
            width: 'auto',
            height: '100%'
        }
    },
}))

export default function UploadFileDialog({isOpen, onClose, onUpload}) {
    const classes = useStyles();
    const [files, setFiles] = useState([]);
    const [guidelinesVisible, setGuidelinesVisible] = useState(false);

    const {getRootProps, getInputProps} = useDropzone({
        accept: 'image/jpeg, image/jpg, image/png',
        maxFiles: 1,
        maxSize: (6 * 1024 * 1024),
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
        }
    })

    const thumbs = files.map(file => (
        <div className={classes.thumb} key={file.name}>
            <div className={classes.thumbInner}>
                <img src={file.preview} alt="preview" />
            </div>
        </div>
    ));

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    const handleUpload = () => {
        if (files.length === 1) {
            onUpload(files[0]);
        }
    }

    return (
        <>
            <Dialog fullWidth maxWidth="md" open={isOpen} onClose={onClose} >
                <DialogTitle id="upload-images" disableTypography style={{padding: 16, margin: 0}}>
                    <Typography variant="h6"> Upload File</Typography>
                    <IconButton onClick={onClose} style={{position: 'absolute', right: 8, top: 8}}> <CloseIcon /> </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Paper variant="outlined" className={classes.paper} {...getRootProps()} >
                        <input {...getInputProps()} />
                        <div className={classes.thumbsContainer}>
                            {thumbs}
                        </div>
                        <div className={classes.helpText}>
                            <CloudUpload />
                            <p>Drag 'n' drop some files here, or click to select files</p>
                        </div>
                    </Paper>
                    <DialogContentText>
                        <ul>
                            <li>The size of each picture should be no less than 500 Kb and no greater than 5 Mb</li>
                            <li>Supported file types - .jpg / .jpeg</li>
                        </ul>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => setGuidelinesVisible(true)} color="secondary">Do’s and Don’ts</Button>
                    <Button variant="contained" disabled={files?.length !== 1} onClick={handleUpload} color="primary"> upload </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth maxWidth="lg" open={guidelinesVisible} onClose={() => setGuidelinesVisible(false)} >
                <DialogContent style={{background: '#292D32'}}>
                    <IconButton onClick={() => setGuidelinesVisible(false)} style={{position: 'absolute', right: 8, top: 8}}>
                        <CloseIcon />
                    </IconButton>
                    <DosAndDonts />
                </DialogContent>
            </Dialog>
        </>
    )
}
